import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("bffy_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("bffy_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const persist = (data) => {
    localStorage.setItem("bffy_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => persist((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => persist((await api.post("/auth/register", { name, email, password })).data);
  const googleAuth = async (sessionId) => persist((await api.post("/auth/google", {}, { headers: { "X-Session-ID": sessionId } })).data);
  const updateProfile = async (profile) => { const { data } = await api.put("/auth/profile", profile); setUser(data); return data; };
  const setUserData = (u) => setUser(u);
  const persistAuth = (data) => persist(data);
  const logout = () => { localStorage.removeItem("bffy_token"); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleAuth, updateProfile, setUserData, persistAuth, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
